import React, { useState } from 'react';
import { tilmeldNotifikationer } from '../../services/firestoreService';
import { useToast } from '../shared/Toast';
import Button from '../shared/Button';
import DannebrogFlag from '../shared/DannebrogFlag';
import styles from './Form.module.scss';

const NotifikationForm: React.FC = () => {
  const { showSuccess, showError } = useToast();
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const [email, setEmail] = useState('');
  const [officielle, setOfficielle] = useState(false);
  const [maerkeDage, setMaerkeDage] = useState(true);
  const [foedselsDage, setFoedselsDage] = useState(true);
  const [varslingsDage, setVarslingsDage] = useState('0');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    if (!officielle && !maerkeDage && !foedselsDage) {
      showError('Vælg mindst én type begivenhed.');
      return;
    }

    setSubmitting(true);
    try {
      await tilmeldNotifikationer({
        email: email.trim().toLowerCase(),
        abonnererPaa: {
          officielle,
          maerkeDage,
          foedselsDage,
        },
        varslingsDage: parseInt(varslingsDage),
      });
      setSuccess(true);
      showSuccess('Du er tilmeldt!');
    } catch (err) {
      console.error(err);
      showError('Noget gik galt. Prøv igen.');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div className={styles.successBox}>
        <div className={styles.successIcon}>✓</div>
        <h3>Du er tilmeldt!</h3>
        <p>
          <strong>{email}</strong> modtager fremover notifikationer om flagdage på Askevej.
        </p>
        <Button
          variant="secondary"
          onClick={() => {
            setSuccess(false);
            setEmail('');
          }}
        >
          Tilmeld en anden email
        </Button>
      </div>
    );
  }

  return (
    <form className={styles.form} onSubmit={handleSubmit} noValidate>
      <div className={styles.field}>
        <label htmlFor="notif-email" className={styles.label}>
          Email-adresse <span className={styles.required}>*</span>
        </label>
        <input
          id="notif-email"
          type="email"
          className={styles.input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="din@email.dk"
          required
          inputMode="email"
          autoComplete="email"
        />
      </div>

      <div className={styles.field}>
        <fieldset className={styles.fieldset}>
          <legend className={styles.label}>Modtag notifikationer om</legend>
          <div className={styles.checkboxGroup}>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={officielle}
                onChange={(e) => setOfficielle(e.target.checked)}
                className={styles.checkbox}
              />
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                <DannebrogFlag size={16} /> Officielle flagdage
              </span>
            </label>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={maerkeDage}
                onChange={(e) => setMaerkeDage(e.target.checked)}
                className={styles.checkbox}
              />
              <span>📅 Mærkedage på Askevej</span>
            </label>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={foedselsDage}
                onChange={(e) => setFoedselsDage(e.target.checked)}
                className={styles.checkbox}
              />
              <span>🎂 Fødselsdage på Askevej</span>
            </label>
          </div>
        </fieldset>
      </div>

      <div className={styles.field}>
        <label htmlFor="notif-varsling" className={styles.label}>
          Varsel
        </label>
        <select
          id="notif-varsling"
          className={styles.select}
          value={varslingsDage}
          onChange={(e) => setVarslingsDage(e.target.value)}
        >
          <option value="0">På dagen</option>
          <option value="1">1 dag før</option>
          <option value="3">3 dage før</option>
          <option value="7">7 dage før</option>
        </select>
        <span className={styles.hint}>Du modtager email på dagen eller det valgte antal dage inden begivenheden.</span>
      </div>

      <Button type="submit" disabled={submitting || !email.trim()} fullWidth>
        {submitting ? 'Tilmelder...' : 'Tilmeld notifikationer'}
      </Button>
    </form>
  );
};

export default NotifikationForm;
